import ReportsAdapter from './base';

export default class RubricFamily extends ReportsAdapter {
  modelNamePlural = 'rubric-families';
}
